import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import Properties from './pages/Properties';
import Rolepermission from './pages/Rolepermission';
import User from './pages/User';
import NotFound from './pages/Page404';
import Requests from './pages/Inquiry';
import Forgot from './pages/Forgot';
import ChangePassword from './pages/ChangePassword';
import OtpVerification from './pages/OtpVerification';
import Reservations from './pages/Reservations';
import Feedback from './pages/Feedback';
import Bugs from './pages/Bugs';
import Faqs from './pages/Faqs';
import FaqCategories from './pages/FaqCategories';
import Wallet from './pages/Wallet';
import Brands from './pages/Brands';
import Colors from './pages/Colors';
import Sizes from './pages/Sizes';
import Conditions from './pages/Conditions';
import Categories from './pages/Categories';
import Jobs from './pages/Jobs';
import Orders from './pages/Orders';
import Withdraw_request from './pages/Withdraw_Request';
import DashboardApp from './pages/DashboardApp';
import Players from './pages/Players';
import AdminUsers from './pages/AdminUsers';
import ClutchRoles from './pages/ClutchRoles';
import ClutchPermissions from './pages/ClutchPermissions';
import ClutchRolePermissions from './pages/ClutchRolePermissions';
import Cookies from './pages/Cookies';
import PrivacyPolicy from './pages/PrivacyPolicies';
import LegalInfo from './pages/LegalInfo';
import TermsCondition from './pages/TermsCondition';
import About from './pages/About';
import Banners from './pages/Banner';
import ProtectionFee from './pages/ProtectionFee';
import DeliveryFee from './pages/DeliveryFee';
import OrderDiscount from './pages/OrderDiscount';
import Refund_Request from './pages/Refund_Request';
import Earnings from './pages/Earnings';
import Customers from './pages/Customers';
import ImageGuideline from './pages/ImageGuideline';
import CustomersCompanyProfile from './pages/CustomersCompanyProfile';
import Companies from './pages/Companies';
import Products from './pages/Products';
import Services from './pages/Services';
export default function Router() {
  const localPerm = JSON.parse(localStorage.getItem('permissions') || '[]');
  const token = localStorage.getItem('token');
  const playersRoute = localPerm?.find((item) => item.permission_name === 'players')?.path;
  const initialroute = playersRoute || localPerm?.[0]?.path || '/dashboard/players';

  const canAccess = (permissionName) =>
    localPerm?.filter((item) => item.permission_name?.toLowerCase() === permissionName.toLowerCase())
      ?.length > 0;

  return useRoutes([
    {
      path: '/',
      // element: token ? <Navigate to="/dashboard/app" /> : <LogoOnlyLayout />,
      element: token ? <Navigate to={initialroute} /> : <LogoOnlyLayout />,
      children: [
        { path: 'app', element: <Navigate to="/dashboard/app" /> },
        { path: '/', element: <Navigate to="/login" /> },
        { path: 'login', element: <Login /> },
        { path: 'forgot', element: <Forgot /> },
        { path: 'changePassword', element: <ChangePassword /> },
        { path: 'otpVerification', element: <OtpVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/dashboard/404" /> },
        { path: 'app', element: <Navigate to="/dashboard/players" replace /> },
        {
          path: 'players',
          element: canAccess('players') ? <Players /> : <Navigate to="/404" />
        },
        {
          path: 'users',
          element: canAccess('users') ? <AdminUsers /> : <Navigate to="/404" />
        },
        {
          path: 'roles-list',
          element: canAccess('roles') ? <ClutchRoles /> : <Navigate to="/404" />
        },
        {
          path: 'permissions',
          element: canAccess('permissions') ? <ClutchPermissions /> : <Navigate to="/404" />
        },
        {
          path: 'role-permissions',
          element: canAccess('role-permissions') ? <ClutchRolePermissions /> : <Navigate to="/404" />
        },
        {
          path: 'roles',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'role/permissions')
              ?.length > 0 ? (
              <Rolepermission />
            ) : (
              <Navigate to="/404" />
            )
        },
        // PERMISSSION WILL BE CHANGES AFTER BACKEND ADDITION
        {
          path: 'companies',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'role/permissions')
              ?.length > 0 ? (
              <Companies />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'products',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'role/permissions')
              ?.length > 0 ? (
              <Products />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'services',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'role/permissions')
              ?.length > 0 ? (
              <Services />
            ) : (
              <Navigate to="/404" />
            )
        },
        // PERMISSSION WILL BE CHANGES AFTER BACKEND ADDITION
        {
          path: 'jobs',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'jobs')?.length >
            0 ? (
              <Jobs />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'brands',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'brands')?.length >
            0 ? (
              <Brands />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'colors',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'colors')?.length >
            0 ? (
              <Colors />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'conditions',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'conditions')
              ?.length > 0 ? (
              <Conditions />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'sizes',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'sizes')?.length >
            0 ? (
              <Sizes />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'categories',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'categories')
              ?.length > 0 ? (
              <Categories />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'orders',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'orders')?.length >
            0 ? (
              <Orders />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'users',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'users')?.length >
            0 ? (
              <User />
            ) : (
              <Navigate to="/404" />
            )
        },

        {
          path: 'customers',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'customers')?.length >
            0 ? (
              <Customers />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'customers/customerscompanyprofile',
          element: <CustomersCompanyProfile />
          // localPerm?.filter((item) => item.permission_name.toLowerCase() === 'earnings')?.length >
          // 0 ? (
          // ) : (
          //   <Navigate to="/404" />
          // )
        },

        {
          path: 'subscriptions',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'subscriptions')
              ?.length > 0 ? (
              <Properties />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'reservations',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'reservations')
              ?.length > 0 ? (
              <Reservations />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'withdraw_request',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'withdraw request')
              ?.length > 0 ? (
              <Withdraw_request />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'inquiry',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'inquiries')?.length >
            0 ? (
              <Requests />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'faqs',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'faqs')?.length >
            0 ? (
              <Faqs />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'faq_categories',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'faq categories')
              ?.length > 0 ? (
              <FaqCategories />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'feedbacks',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'feedback')?.length >
            0 ? (
              <Feedback />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'subscription',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'Wallets')?.length >
            0 ? (
              <Wallet />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'bug_reports',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'bug reports')
              ?.length > 0 ? (
              <Bugs />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'terms_and_policies',
          element: <TermsCondition />
          // localPerm?.filter((item) => item.permission_name.toLowerCase() == 'terms_and_policies')
          //   ?.length > 0 ? (
          //   <TermsCondition />
          // ) : (
          //   <Navigate to="/404" />
          // )
        },
        {
          path: 'cookie',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'cookie consent')
              ?.length > 0 ? (
              <Cookies />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'legal_info',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'legal info')
              ?.length > 0 ? (
              <LegalInfo />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'privacy_policy',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'privacy policy')
              ?.length > 0 ? (
              <PrivacyPolicy />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'about_vint',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'about vint')
              ?.length > 0 ? (
              <About />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'banners',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'banners')?.length >
            0 ? (
              <Banners />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'image_guidelines',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'image guideline')
              ?.length > 0 ? (
              <ImageGuideline />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'refund_request',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'refund request')
              ?.length > 0 ? (
              <Refund_Request />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'buyer_protection_fee',
          element:
            localPerm?.filter(
              (item) => item.permission_name.toLowerCase() == 'buyer protection fee'
            )?.length > 0 ? (
              <ProtectionFee />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'delivery_fees',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'delivery fee')
              ?.length > 0 ? (
              <DeliveryFee />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'discounts',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() === 'discount')?.length >
            0 ? (
              <OrderDiscount />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'earnings',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() === 'earnings')?.length >
            0 ? (
              <Earnings />
            ) : (
              <Navigate to="/404" />
            )
        }
      ]
    },

    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
